import { render, staticRenderFns } from "./Desk.vue?vue&type=template&id=718d8888&scoped=true&"
import script from "./Desk.vue?vue&type=script&lang=js&"
export * from "./Desk.vue?vue&type=script&lang=js&"
import style0 from "./Desk.vue?vue&type=style&index=0&id=718d8888&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718d8888",
  null
  
)

export default component.exports